import { motoGearClient } from "../clients/motoGearClient"
import type {
  MotoGearResponseDto,
  CreateMotoGearDto,
  UpdateMotoGearDto,
  MotoGearListParams,
  MotoGearListResponseDto,
  DeleteMotoGearResponseDto,
} from "../types/motoGear.types"

/**
 * Moto Gear Service
 * Business logic layer - handles API responses, errors, and side effects
 */
export const motoGearService = {
  /**
   * Get moto gear by ID
   */
  getMotoGearById: async (id: string): Promise<MotoGearResponseDto> => {
    try {
      const gear = await motoGearClient.getMotoGearById(id)
      return gear
    } catch (error: any) {
      throw error
    }
  },

  /**
   * List moto gears with filters
   */
  getMotoGears: async (params?: MotoGearListParams): Promise<MotoGearListResponseDto> => {
    try {
      const response = await motoGearClient.getMotoGears(params)
      return response
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Create moto gear
   */
  createMotoGear: async (data: CreateMotoGearDto): Promise<MotoGearResponseDto> => {
    try {
      const gear = await motoGearClient.createMotoGear(data)
      return gear
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Update moto gear
   */
  updateMotoGear: async (
    id: string,
    data: UpdateMotoGearDto
  ): Promise<MotoGearResponseDto> => {
    try {
      const gear = await motoGearClient.updateMotoGear(id, data)
      return gear
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Delete moto gear
   */
  deleteMotoGear: async (id: string): Promise<DeleteMotoGearResponseDto> => {
    try {
      const response = await motoGearClient.deleteMotoGear(id)
      return response
    } catch (error: any) {
      throw error
    }
  },
}

export default motoGearService
